import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Grow,
  IconButton,
  InputAdornment,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Slide,
  TextField,
  ThemeProvider,
  Tooltip,
  Typography,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import JumboDdPopover from "@jumbo/components/JumboDdPopover";
import Div from "@jumbo/shared/Div";
import useJumboTheme from "@jumbo/hooks/useJumboTheme";
import axios from "axios";
import { BASE_URL, Tenantname } from "app/services/auth-services";
import { toast } from "react-toastify";
import { MdCall, MdEmail } from "react-icons/md";
import { FaCamera, FaEdit, FaSave, FaUserCircle } from "react-icons/fa";
import Draggable from "react-draggable";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { DateFormatter } from "app/shared/ReuseComponents/DateFormatter";
import {
  ErpCancelButton,
  ErpCreateButton,
  ErpSaveUpdateButton,
} from "app/shared/ReuseComponents/ButtonComponent";
import { AvatarFont, DisplayFlex } from "app/shared/ReuseComponents/ERPstyle";
import { BsChatText } from "react-icons/bs";
import { handleError } from "app/pages/auth-pages/login/AuthGuard";

export function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const AuthUserDropdown = () => {
  const navigate = useNavigate();

  const token = localStorage.getItem("accesstoken");

  const header = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  };

  const { theme } = useJumboTheme();
  const [open, setOpen] = useState(false);

  const [openUserProfile, setOpenUserProfile] = useState(false);

  const [editDetails, setEditDetails] = useState({
    UserName: false,
    UserEmail: false,
    UserMobileNo: false,
    UserCountry: false,
    UserState: false,
    UserStreet: false,
    UserCity: false,
    UserArea: false,
    UserBuildingNo: false,
    EditStaus: false,
  });
  const [editDetails1, setEditDetails1] = useState({});

  // state for change the user details
  const [profilePhoto, setProfilePhoto] = useState();
  const [base64, setBase64] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [fileName, setFileName] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const [id, setId] = useState("");
  const [mailId, setMailId] = useState("");
  const [mailId1, setMailId1] = useState("");
  const [provider, setProvider] = useState("select");
  const [mailPassword, setMailPassword] = useState("");
  const [smtpHost, setSmtpHost] = useState("");
  const [smtpPort, setSmtpPort] = useState("");
  const [imapHost, setImapHost] = useState("");
  const [imapPort, setImapPort] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [clientId, setClientId] = useState("");
  const [refreshAvatar, setRefreshAvatar] = useState(0);

  const userId = parseInt(localStorage.getItem("UserId"));
  let userDetails = localStorage.getItem("UserDetails");
  userDetails = JSON.parse(userDetails);

  const urlParams = new URLSearchParams(window.location.search);

  const handleChangeEdit = () => {
    setEditDetails((prev) => ({
      ...prev,
      UserName: true,
      UserEmail: true,
      UserMobileNo: true,
      UserCountry: true,
      UserState: true,
      UserStreet: true,
      UserCity: true,
      UserArea: true,
      UserBuildingNo: true,
      EditStaus: true,
    }));
  };

  const handleCancel = () => {
    setEditDetails({
      ...editDetails1,
      UserName: false,
      UserEmail: false,
      UserMobileNo: false,
      UserCountry: false,
      UserState: false,
      UserStreet: false,
      UserCity: false,
      UserArea: false,
      UserBuildingNo: false,
      EditStaus: false,
    });
    getFetchImage(editDetails1); // reftech the user image
  };

  const onLogout = async () => {
    // update user data
    var userspayload = {
      id: userDetails?.id,
    };
    await axios
      .put(`${BASE_URL}/Felix/UpdateUserLoginFlagFalse/`, userspayload, header)
      .then((res) => {
        console.log(res.data);
        localStorage.removeItem("accesstoken");
        localStorage.clear();
        navigate("/");
      })
      .catch((error) => {
        console.log("ds", error);
        handleError(error);
      });
  };

  const handleOpenUserProfile = () => {
    setOpenUserProfile(true);
  };

  const handleOpenMailConfiguration = () => {
    setOpen(true);
  };

  useEffect(() => {
    const getRequest = async () => {
      if (userId) {
        await axios
          .get(
            `${BASE_URL}/Felix/MailConfigurationCRUD/?MailId=${userDetails?.email}`,
            header,
          )
          .then((res) => {
            console.log(res);
            if (res) {
              setId(res?.data?.id);
              setMailId(res?.data?.MailId);
              setMailId1(res?.data?.MailId);
              setProvider(res?.data?.provider);
              setMailPassword(res?.data?.MailPassword);
              setSmtpHost(res?.data?.SMTPHost);
              setSmtpPort(res?.data?.SMTPPort);
              setImapHost(res?.data?.IMAPHost);
              setImapPort(res?.data?.IMAPPort);
              setSecretKey(res?.data?.SecretKey);
              setAccessToken(res?.data?.Access_Token);
              setClientId(res?.data?.Client_Id);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }

      fetch(`${BASE_URL}${userDetails?.User_Photo}`)
        .then((response) => response.arrayBuffer())
        .then((buffer) => {
          const base64 = btoa(
            new Uint8Array(buffer).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              "",
            ),
          );
          setBase64(base64);
          const urlParts = userDetails?.User_Photo.split("/");
          setProfilePhoto(urlParts[urlParts.length - 1]);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    getRequest();
  }, [open]);

  // useEffect(() => {
  //   setEditDetails({
  //     ...editDetails,
  //     "username": userDetails?.username,
  //     "first_name": userDetails?.first_name,
  //     "last_name": userDetails?.last_name,
  //     "email": userDetails?.email,
  //     "Designation": userDetails?.Designation,
  //     "User_Photo": base64 || userDetails?.User_Photo,
  //     "User_Photo_Name": fileName || "file.jpg",
  //     "PhoneNo": userDetails?.PhoneNo,
  //     "BuildingHuseNo": userDetails?.BuildingHuseNo,
  //     "Street": userDetails?.Street,
  //     "Area": userDetails?.Area,
  //     "City": userDetails?.City,
  //     "State": userDetails?.State,
  //     "Country": userDetails?.Country,
  //     "last_login": userDetails?.last_login,
  //   });
  //   setEditDetails1({
  //     ...editDetails,
  //     "username": userDetails?.username,
  //     "first_name": userDetails?.first_name,
  //     "last_name": userDetails?.last_name,
  //     "email": userDetails?.email,
  //     "Designation": userDetails?.Designation,
  //     "User_Photo": base64 || userDetails?.User_Photo,
  //     "User_Photo_Name": fileName || "file.jpg",
  //     "PhoneNo": userDetails?.PhoneNo,
  //     "BuildingHuseNo": userDetails?.BuildingHuseNo,
  //     "Street": userDetails?.Street,
  //     "Area": userDetails?.Area,
  //     "City": userDetails?.City,
  //     "State": userDetails?.State,
  //     "Country": userDetails?.Country,
  //     "last_login": userDetails?.last_login,
  //   });
  //   getFetchImage(userDetails)
  // }, []);

  // image upload function
  const handleChangeImage = (e) => {
    // let file = e.target.files[0];
    // setProfilePhoto(file?.name)
    // if (file) {
    //   const reader = new FileReader();
    //   reader.onload = handleReaderLoaded;
    //   reader.readAsArrayBuffer(file);
    // }

    const file = e.target.files[0];
    if (file) {
      console.log("File uploaded:", file);
      setProfilePhoto(file?.name);
      setEditDetails({ ...editDetails, User_Photo: file?.name || "no name" });
      setFileName(file?.name);
      const imageUrl = URL.createObjectURL(file);
      console.log("imageUrl:", imageUrl);
      setSelectedImage(imageUrl);

      if (file) {
        const reader = new FileReader();
        reader.onload = handleReaderLoaded;
        reader.readAsArrayBuffer(file);
      }
    }
  };

  const handleReaderLoaded = (e) => {
    let arrayBuffer = e.target.result;
    let binaryString = String.fromCharCode.apply(
      null,
      new Uint8Array(arrayBuffer),
    );
    setBase64(btoa(binaryString));
  };

  const getFetchImage = (data) => {
    try {
      if (data?.User_Photo) {
        let url = data?.User_Photo;
        let parts = url.split("/media/");

        let image =
          (BASE_URL + data?.User_Photo?.split(BASE_URL)[1] ||
            data?.User_Photo) ??
          "";

        setSelectedImage(image);
        setFileName(parts[1]);
        console.log("image upload", parts[1], {
          imageSample: data?.User_Photo,
          imgae2: data?.User_Photo?.split("https://backend.crmfarm.app")[1],
        });
        if (Boolean(data?.User_Photo)) {
          try {
            // fetch(`${BASE_URL}${data?.User_Photo}`)
            fetch(`${BASE_URL}${userDetails?.User_Photo}`)
              .then((data) => data.arrayBuffer())
              .then((buffer) => {
                const base64 = btoa(
                  new Uint8Array(buffer).reduce(
                    (data, byte) => data + String.fromCharCode(byte),
                    "",
                  ),
                );
                setBase64(base64);
                const urlParts = data?.User_Photo.split("/");
                console.log("urlParts", urlParts);
              })
              .catch((error) => {
                console.log(error);
              });
          } catch (error) {
            console.log("error", error);
          }
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  // update user details
  const handleSubmitUserDetails = (e) => {
    // e.preventDefault();
    const userspayload = {
      ...editDetails,
      User_Photo: base64,
      User_Photo_Name: profilePhoto,
      Organization_Id: parseInt(localStorage.getItem("OrganizationId")),
      Company_Id: parseInt(localStorage.getItem("OrganizationId")),
      Created_By: parseInt(localStorage.getItem("UserId")),
      Updated_By: parseInt(localStorage.getItem("UserId")),
    };
    axios
      .put(`${BASE_URL}/Felix/Usersignup/`, userspayload, header)
      .then((res) => {
        console.log(res.data);
        if (res?.status === 200 && res?.data?.id) {
          toast.success("User Details Updated Successfully");

          localStorage.setItem("UserDetails", JSON.stringify(res.data));

          window.dispatchEvent(
            new CustomEvent("profile-updated", { detail: res.data }),
          );

          setOpenUserProfile(false);
        }
      })
      .catch((error) => {
        console.log("ds", error);
      });
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // update mail configuration

  const handleSubmitMailConfigure = async (e) => {
    e.preventDefault();

    const userId = parseInt(localStorage.getItem("UserId"));
    const organizationId = parseInt(localStorage.getItem("OrganizationId"));
    const isCorporateUser = userDetails?.UserType === "Corporate";

    const payload = {
      provider: provider,
      SMTPHost: smtpHost,
      SMTPPort: smtpPort,
      IMAPHost: imapHost,
      IMAPPort: imapPort,
      MailId: mailId,
      MailPassword: mailPassword,
      SecretKey: secretKey,
      Access_Token: accessToken,
      Client_Id: clientId,
      User_Id: userId,
      Company_Id: organizationId,
      Created_By: userId,
      Updated_By: userId,
    };

    try {
      let response;

      if (!id) {
        // CREATE (POST)
        response = await axios.post(
          `${BASE_URL}/Felix/MailConfigurationCRUD/`,
          payload,
          header,
        );

        if (response?.status === 200 && response?.data?.id) {
          toast.success("Mail configured successfully");
          setOpen(false);

          // If Corporate user, post to UserAdminMailConfiguration as well
          if (isCorporateUser) {
            try {
              await axios.post(
                `${BASE_URL}/Felix/UserAdminMailConfigurationCRUD/`,
                payload,
                header,
              );
            } catch (error) {
              console.log(error);
            }
          }
        } else {
          toast.warning("Mail configuration failed. Please check the inputs.");
        }
      } else {
        // UPDATE (PUT)
        const updatePayload = {
          ...payload,
          id,
          Organization_Id: organizationId, // Ensure this is included in PUT
        };

        response = await axios.put(
          `${BASE_URL}/Felix/MailConfigurationCRUD/`,
          updatePayload,
          header,
        );

        if (response?.status === 200 && response?.data?.id) {
          toast.success("Mail configuration updated successfully");
          setOpen(false);

          if (isCorporateUser) {
            try {
              await axios.put(
                `${BASE_URL}/Felix/UserAdminMailConfigurationCRUD/`,
                updatePayload,
                header,
              );
            } catch (error) {
              console.log(error);
            }
          }
        } else {
          toast.warning(
            "Failed to update configuration. Please check the inputs.",
          );
        }
      }
    } catch (error) {
      console.error("Mail Configuration Error:", error);
      toast.error(
        error?.response?.data?.Error || error.message || "Something went wrong",
      );
    }
  };

  const handleGetUserDetails = async () => {
    try {
      const response = await axios.get(
        `${BASE_URL}/Felix/Usersignup/?username=${userDetails?.username}`,
      );
      if (response?.data?.id) {
        setEditDetails({
          ...response?.data,
          UserName: false,
          UserEmail: false,
          UserMobileNo: false,
          UserCountry: false,
          UserState: false,
          UserStreet: false,
          UserCity: false,
          UserArea: false,
          UserBuildingNo: false,
          EditStaus: false,
        });

        getFetchImage(response?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleGetUserDetails();
  }, [userDetails?.username]);

  useEffect(() => {
    const handleProfileUpdate = async (event) => {
      const updatedUser = event.detail;

      // update local userDetails
      localStorage.setItem("UserDetails", JSON.stringify(updatedUser));

      // force re-render avatar
      setRefreshAvatar((prev) => prev + 1);

      // also reload latest data from API (important)
      await handleGetUserDetails();
    };

    window.addEventListener("profile-updated", handleProfileUpdate);

    return () => {
      window.removeEventListener("profile-updated", handleProfileUpdate);
    };
  }, []);

  // no action auto logout
  const inactivityTimeout = 1800000; // 30 minutes in milliseconds

  useEffect(() => {
    let logoutTimer;

    const resetTimeout = () => {
      clearTimeout(logoutTimer);
      logoutTimer = setTimeout(onLogout, inactivityTimeout);
    };

    const handleUserActivity = () => {
      resetTimeout();
    };

    const events = [
      "mousemove",
      "keydown",
      "click",
      "mouseenter",
      "mouseleave",
    ];

    events.forEach((event) => {
      window.addEventListener(event, handleUserActivity);
    });

    resetTimeout();

    return () => {
      clearTimeout(logoutTimer);
      events.forEach((event) => {
        window.removeEventListener(event, handleUserActivity);
      });
    };
  }, [onLogout, inactivityTimeout]);

  const handleBeforeUnload = (event) => {
    const navigationType = event.currentTarget.performance?.navigation?.type;

    if (navigationType !== 1 && event.clientY < 0) {
      onLogout();
    }
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      // Call your function here
      console.log("Laptop is going to sleep or the tab is hidden");
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const handleTabClose = () => {
    onLogout();
  };

  useEffect(() => {
    window.addEventListener("unload", handleTabClose);
    return () => {
      window.removeEventListener("unload", handleTabClose);
    };
  }, []);

  // function for hide a password
  const hidePassword = (password) => {
    return "*".repeat(password.length);
  };

  const getProfileImage = (updatedImage) => {
    // Handle updated image (after save)
    if (editDetails?.EditStaus && selectedImage) {
      return selectedImage;
    }

    if (updatedImage) {
      return `${BASE_URL}${updatedImage}`;
    }

    // Handle image sources with BASE_URL prefixing
    const getFullUrl = (path) => {
      if (!path) return undefined;
      // Check if it's already a full URL
      if (
        path.startsWith("http") ||
        path.startsWith("blob:") ||
        path.startsWith("data:")
      ) {
        return path;
      }
      // Add BASE_URL prefix for relative paths
      return `${BASE_URL}${path}`;
    };

    // Check edit details first
    if (editDetails?.User_Photo) {
      return getFullUrl(editDetails.User_Photo);
    }

    if (editDetails?.EditStaus && !selectedImage) {
      return getFullUrl(editDetails.User_Photo);
    }

    // No image available
    return getFullUrl(editDetails.User_Photo);
  };

  return (
    <ThemeProvider theme={theme}>
      <JumboDdPopover
        triggerButton={
          <Tooltip title="User Profile" placement="top-start">
            <Avatar
              // src={`${BASE_URL}${userDetails?.User_Photo}`}

              key={refreshAvatar}
              src={getProfileImage()}
              sx={{ boxShadow: 30, cursor: "pointer" }}
            />
          </Tooltip>
        }
      >
        <Div
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            p: (theme) => theme.spacing(2.5),
            width: "260px",
          }}
        >
          <Avatar
            // src={`${BASE_URL}${userDetails?.User_Photo}`}
            src={getProfileImage()}
            alt={userDetails?.User_Name}
            sx={{ width: 60, height: 60, mb: 2 }}
          />
          <Typography variant={"h5"}>
            {userDetails?.first_name} {userDetails?.last_name}
          </Typography>
          <Typography variant={"body1"} color="text.secondary">
            {userDetails?.Designation}
          </Typography>
        </Div>
        <Divider />
        <nav>
          <List disablePadding sx={{ pb: 1 }}>
            <ListItemButton onClick={handleOpenUserProfile}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <PersonOutlineIcon />
              </ListItemIcon>
              <ListItemText primary="Profile" sx={{ my: 0 }} />
            </ListItemButton>
            <ListItemButton onClick={handleOpenMailConfiguration}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <EditOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Mail Configuration" sx={{ my: 0 }} />
            </ListItemButton>
            <ListItemButton onClick={() => navigate(`/ChatandSupport`)}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <BsChatText size={17} />
              </ListItemIcon>
              <ListItemText primary="Chat & Support" sx={{ my: 0 }} />
            </ListItemButton>
            <ListItemButton onClick={onLogout}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <LogoutIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" sx={{ my: 0 }} />
            </ListItemButton>
          </List>
        </nav>
      </JumboDdPopover>

      {/* dialog box for user profile */}
      <Dialog
        open={openUserProfile}
        onClose={() => setOpenUserProfile(false)}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="md"
        fullWidth
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Div id="draggable-dialog-title" sx={{ p: 3, minHeight: "400px" }}>
          <Typography variant="h3">User Profile</Typography>
          <DialogContent
            sx={{ minHeight: "300px", padding: { xs: "4px !important" } }}
          >
            <Grow in={true} style={{ transformOrigin: "0 0 0" }} timeout={1000}>
              <Grid
                container
                sx={{
                  my: 2,
                  backgroundColor: "#ededed !important",
                  borderRadius: "10px",
                }}
              >
                <Grid
                  item
                  xs={12}
                  md={5.5}
                  sx={[DisplayFlex, { justifyContent: "center", my: 2.5 }]}
                >
                  <Div sx={{ position: "relative" }}>
                    {/* <AvatarCircle
                      image={selectedImage}
                      bgColor={"#115857"}
                      boxShadow="box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;"
                      size="120px"
                      fontsize="32px"
                    /> */}
                    <Avatar
                      src={getProfileImage()}
                      sx={[
                        AvatarFont,
                        {
                          background: "#115857",
                          width: "120px",
                          height: "120px",
                          fontSize: "32px",
                          boxShadow:
                            "box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;",
                        },
                      ]}
                    />

                    {Boolean(editDetails?.EditStaus) && (
                      <Div
                        sx={{
                          position: "absolute",
                          bottom: "0px",
                          right: "5px",
                          zIndex: 9999,
                          cursor: "pointer !important",
                        }}
                      >
                        <IconButton
                          size="small"
                          style={{
                            backgroundColor: "#e9e9e9",
                            cursor: "pointer !important",
                          }}
                        >
                          <input
                            type="file"
                            placeholder="Profile Upload"
                            onChange={handleChangeImage}
                            style={{
                              opacity: 0,
                              position: "absolute",
                              zIndex: 1,
                              width: "100%",
                              height: "100%",
                              cursor: "pointer !important",
                            }}
                          />
                          <FaCamera color="#000" />
                        </IconButton>
                      </Div>
                    )}
                  </Div>
                </Grid>

                <Grid item xs={12} md={0.5} sx={{ mt: 2 }}></Grid>

                <Grid item xs={12} md={6}>
                  <Div sx={{ mt: 0.8, display: "flex", alignItems: "center" }}>
                    <IconButton
                      className="col-2"
                      sx={{ backgroundColor: "transparent !important" }}
                    >
                      <FaUserCircle color="black" />
                    </IconButton>
                    {editDetails?.UserName === false ? (
                      <Typography className="input-label col-9">
                        {editDetails?.first_name} - {editDetails?.last_name}
                      </Typography>
                    ) : (
                      <Div
                        className="col-9"
                        sx={{ display: "flex", gap: "10px" }}
                      >
                        <TextField
                          className="input-box col-7"
                          name="first_name"
                          value={editDetails?.first_name}
                          onChange={(e) =>
                            setEditDetails({
                              ...editDetails,
                              first_name: e.target.value,
                            })
                          }
                          placeholder="Enter Your First Name"
                        />
                        <TextField
                          className="input-box col-5"
                          name="last_name"
                          value={editDetails?.last_name}
                          onChange={(e) =>
                            setEditDetails({
                              ...editDetails,
                              last_name: e.target.value,
                            })
                          }
                          placeholder="Enter Your Last Name"
                          sx={{ pr: { xs: 0, md: 1 } }}
                        />
                      </Div>
                    )}
                  </Div>
                  <Div sx={{ mt: 0.8, display: "flex", alignItems: "center" }}>
                    <IconButton
                      className="col-2"
                      sx={{ backgroundColor: "transparent !important" }}
                    >
                      <MdEmail color="black" />
                    </IconButton>
                    {editDetails?.UserEmail === false ? (
                      <Typography className="input-label col-9">
                        {editDetails?.email}
                      </Typography>
                    ) : (
                      <TextField
                        className="input-box col-9"
                        name="email"
                        value={editDetails?.email}
                        onChange={(e) =>
                          setEditDetails({
                            ...editDetails,
                            email: e.target.value,
                          })
                        }
                        placeholder="Enter Your Email Id"
                      />
                    )}
                  </Div>
                  <Div sx={{ mt: 0.8, display: "flex", alignItems: "center" }}>
                    <IconButton
                      className="col-2"
                      sx={{ backgroundColor: "transparent !important" }}
                    >
                      <MdCall color="black" />
                    </IconButton>
                    {editDetails?.UserMobileNo === false ? (
                      <Typography className="input-label col-9">
                        {editDetails?.PhoneNo || ""}
                      </Typography>
                    ) : (
                      <TextField
                        className="input-box col-9"
                        name="PhoneNo"
                        value={editDetails?.PhoneNo}
                        onChange={(e) =>
                          setEditDetails({
                            ...editDetails,
                            PhoneNo: e.target.value,
                          })
                        }
                        placeholder="Enter Your Mobile No"
                      />
                    )}
                  </Div>
                </Grid>
              </Grid>
            </Grow>
            <Grow in={true} style={{ transformOrigin: "0 0 0" }} timeout={1000}>
              <Grid container spacing={2} sx={{ mt: 1 }}>
                <Grid item xs={12} md={1} sx={{ mt: 2 }}></Grid>

                <Grid item xs={12} md={5.5} sx={{ mt: 2 }}>
                  <Div sx={{ mt: 0.8, display: "flex", alignItems: "center" }}>
                    <Typography className="input-label col-sm-11 col-md-4">
                      Role
                    </Typography>
                    <Typography className="input-label col-1">:</Typography>
                    <Typography className="input-label col-sm-12 col-md-6">
                      {editDetails?.Designation}
                    </Typography>
                  </Div>
                  <Div sx={{ mt: 0.8, display: "flex", alignItems: "center" }}>
                    <Typography className="input-label col-sm-11 col-md-4">
                      Country
                    </Typography>
                    <Typography className="input-label col-1">:</Typography>
                    {editDetails?.UserCountry === false ? (
                      <Typography className="input-label col-sm-12 col-md-6">
                        {editDetails?.Country}
                      </Typography>
                    ) : (
                      <TextField
                        className="input-box col-6"
                        name="Country"
                        value={editDetails?.Country}
                        onChange={(e) =>
                          setEditDetails({
                            ...editDetails,
                            Country: e.target.value,
                          })
                        }
                        placeholder="Enter Your Country"
                      />
                    )}
                  </Div>
                  <Div sx={{ mt: 0.8, display: "flex", alignItems: "center" }}>
                    <Typography className="input-label col-sm-11 col-md-4">
                      City
                    </Typography>
                    <Typography className="input-label col-1">:</Typography>
                    {editDetails?.UserName === false ? (
                      <Typography className="input-label col-sm-12 col-md-6">
                        {editDetails?.City}
                      </Typography>
                    ) : (
                      <TextField
                        className="input-box col-6"
                        name="City"
                        value={editDetails?.City}
                        onChange={(e) =>
                          setEditDetails({
                            ...editDetails,
                            City: e.target.value,
                          })
                        }
                        placeholder="Enter Your City"
                      />
                    )}
                  </Div>

                  <Div sx={{ mt: 0.8, display: "flex", alignItems: "center" }}>
                    <Typography className="input-label col-sm-11 col-md-4">
                      Area
                    </Typography>
                    <Typography className="input-label col-1">:</Typography>
                    {editDetails?.UserCity === false ? (
                      <Typography className="input-label col-sm-12 col-md-6">
                        {editDetails?.Area}
                      </Typography>
                    ) : (
                      <TextField
                        className="input-box col-6"
                        name="Area"
                        value={editDetails?.Area}
                        onChange={(e) =>
                          setEditDetails({
                            ...editDetails,
                            Area: e.target.value,
                          })
                        }
                        placeholder="Enter Your Area Name"
                      />
                    )}
                  </Div>
                  <Div sx={{ mt: 0.8, display: "flex", alignItems: "center" }}>
                    <Typography className="input-label col-sm-11 col-md-4">
                      Last Login
                    </Typography>
                    <Typography className="input-label col-1">:</Typography>
                    <Typography className="input-label col-sm-12 col-md-6">
                      {
                        <DateFormatter
                          date={editDetails?.last_login?.slice(0, 10)}
                        />
                      }{" "}
                      {editDetails?.last_login?.slice(11, 16)}
                      {parseInt(editDetails?.last_login?.slice(11, 16), 10) >=
                      12
                        ? " PM"
                        : " AM"}
                    </Typography>
                  </Div>
                </Grid>

                <Grid item xs={12} md={5.5} sx={{ mt: 2 }}>
                  <Div sx={{ mt: 0.8, display: "flex", alignItems: "center" }}>
                    <Typography className="input-label col-sm-11 col-md-4">
                      Password
                    </Typography>
                    <Typography className="input-label col-1">:</Typography>
                    <Typography className="input-label col-sm-12 col-md-6">
                      {hidePassword(mailPassword) || mailPassword}
                    </Typography>
                  </Div>
                  <Div sx={{ mt: 0.8, display: "flex", alignItems: "center" }}>
                    <Typography className="input-label col-sm-11 col-md-4">
                      State
                    </Typography>
                    <Typography className="input-label col-1">:</Typography>
                    {editDetails?.UserName === false ? (
                      <Typography className="input-label col-sm-12 col-md-6">
                        {editDetails?.State}
                      </Typography>
                    ) : (
                      <TextField
                        className="input-box col-6"
                        name="State"
                        value={editDetails?.State}
                        onChange={(e) =>
                          setEditDetails({
                            ...editDetails,
                            State: e.target.value,
                          })
                        }
                        placeholder="Enter Your State"
                      />
                    )}
                  </Div>
                  <Div sx={{ mt: 0.8, display: "flex", alignItems: "center" }}>
                    <Typography className="input-label col-sm-11 col-md-4">
                      Street
                    </Typography>
                    <Typography className="input-label col-1">:</Typography>
                    {editDetails?.UserState === false ? (
                      <Typography className="input-label col-sm-12 col-md-6">
                        {editDetails?.Street}
                      </Typography>
                    ) : (
                      <TextField
                        className="input-box col-6"
                        name="Street"
                        value={editDetails?.Street}
                        onChange={(e) =>
                          setEditDetails({
                            ...editDetails,
                            Street: e.target.value,
                          })
                        }
                        placeholder="Enter Your Street Name"
                      />
                    )}
                  </Div>
                  <Div sx={{ mt: 0.8, display: "flex", alignItems: "center" }}>
                    <Typography className="input-label col-sm-11 col-md-4">
                      Door No
                    </Typography>
                    <Typography className="input-label col-1">:</Typography>
                    {editDetails?.UserName === false ? (
                      <Typography className="input-label col-sm-12 col-md-6">
                        {editDetails?.BuildingHuseNo}
                      </Typography>
                    ) : (
                      <TextField
                        className="input-box col-6"
                        name="BuildingHuseNo"
                        value={editDetails?.BuildingHuseNo}
                        onChange={(e) =>
                          setEditDetails({
                            ...editDetails,
                            BuildingHuseNo: e.target.value,
                          })
                        }
                        placeholder="Enter Your Building House No"
                      />
                    )}
                  </Div>
                </Grid>
              </Grid>
            </Grow>
          </DialogContent>
          <DialogActions
            className="buttons"
            sx={{ display: "flex", justifyContent: "end" }}
          >
            <Grow
              in={true}
              style={{ transformOrigin: "0 0 0" }}
              {...(true ? { timeout: 1000 } : {})}
            >
              <Grid container mt={2} align="right" spacing={2} pb={2}>
                <Grid item align="right" xs={6}>
                  {!Boolean(editDetails?.EditStaus) ? (
                    <ErpCreateButton
                      name="Edit"
                      icon={<FaEdit />}
                      handleClick={() => handleChangeEdit()}
                    />
                  ) : (
                    <ErpCreateButton
                      name="Update"
                      icon={<FaSave />}
                      handleClick={() => handleSubmitUserDetails()}
                    />
                  )}
                </Grid>
                <Grid item align="left" xs={6}>
                  {!Boolean(editDetails?.EditStaus) ? (
                    <ErpCancelButton
                      label={"Cancel"}
                      onClick={() => setOpenUserProfile(false)}
                    />
                  ) : (
                    <ErpCancelButton
                      label={"Back"}
                      Icon="backIcon"
                      onClick={() => handleCancel()}
                    />
                  )}
                </Grid>
              </Grid>
            </Grow>
          </DialogActions>
        </Div>
      </Dialog>

      {/* dialog box for user profile */}
      {/* <Dialog
        open={openUserProfile}
        onClose={() => setOpenUserProfile(false)}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
        maxWidth="md"
        fullWidth
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <form onSubmit={handleSubmitUserDetails}>
          <Div sx={{ p: 3, minHeight: "400px" }} id="draggable-dialog-title">
            <Typography variant="h3">User Profile</Typography>
            <DialogContent sx={{ minHeight: "300px", padding: { xs: "4px !important" } }}>
              <Grid container xs={12}>
                <Grid item xs={12} md={6}>
                  <Div className="row">
                    <IconButton className="col-2">
                      <FaUserCircle color="black" />
                    </IconButton>
                    <Typography className="input-label col-7">
                      {userDetails?.first_name} {userDetails?.last_name}
                    </Typography>
                  </Div>
                  <Div className="row">
                    <IconButton className="col-2">
                      <MdEmail color="black" />
                    </IconButton>
                    <Typography className="input-label col-7">
                      {userDetails?.email}
                    </Typography>
                  </Div>
                  <Div className="row">
                    <IconButton className="col-2">
                      <MdCall color="black" />
                    </IconButton>
                    <Typography className="input-label col-8">
                      {editMobileNo === false ? (
                        <span>{userDetails?.PhoneNo || ""}</span>
                      ) : (
                        <span>
                          <TextField
                            className="input-box col-8"
                            name="phoneNo"
                            value={phoneNo}
                            onChange={(e) => {
                              const data = e.target.value.trim();
                              setPhoneNo(data);
                            }}
                            placeholder="Enter Your Mobile No"
                          />
                        </span>
                      )}

                      <IconButton
                        className="ms-1"
                        onClick={() => setEditMobileNo(true)}
                      >
                        <MdEdit color="black" />
                      </IconButton>
                    </Typography>
                  </Div>
                  <br />
                  <Div className="row">
                    <Typography className="input-label col-12">
                      Profile Image
                    </Typography>

                    <Div className="col-12">
                      <Card sx={{ minHeight: "180px", width: "180px", p: 2 }}>
                        <img
                          alt="Profile"
                          src={`data:image/png;base64,${base64}`}
                          width={150}
                          height={150}
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        />
                      </Card>
                      <br />
                      <Button
                        component="label"
                        onChange={handleChangeImage}
                        sx={{
                          mt: { sm: 4 },
                          marginTop: { md: "10px" },
                          ml: { xs: 0, md: 4 },
                          color: "#017890",
                          textTransform: "capitalize",
                        }}
                      >
                        Upload Image
                        <TextField
                          hidden
                          accept="image/*"
                          multiple
                          type="file"
                          style={{
                            backgroundColor: "transparent",
                          }}
                          name="companyLogo"
                        />
                      </Button>
                    </Div>
                  </Div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Div className="row">
                    <Typography className="input-label col-sm-11 col-md-4" sx={{ width: { xs: "33%", md: "35%" } }}>Role</Typography>
                    <Typography className="input-label col-1">:</Typography>
                    <Typography className="input-label col-sm-12 col-md-7" sx={{ width: { xs: "55% ", md: "55%" } }}>
                      {userDetails?.Designation}
                    </Typography>
                  </Div>
                  <Div className="row">
                    <Typography className="input-label col-sm-11 col-md-4" sx={{ width: { xs: "33% ", md: "35%" } }}>
                      User Id
                    </Typography>
                    <Typography className="input-label col-1">:</Typography>
                    <Typography className="input-label col-sm-12 col-md-7" sx={{ width: { xs: "55% ", md: "55%" } }}>{userDetails?.User_Id}</Typography>
                  </Div>
                  <Div className="row">
                    <Typography className="input-label col-sm-11 col-md-4" sx={{ width: { xs: "33% ", md: "35%" } }}>
                      Password
                    </Typography>
                    <Typography className="input-label col-1">:</Typography>
                    <Typography className="input-label col-sm-12 col-md-7" sx={{ width: { xs: "55% ", md: "55%" } }}>
                      {hidePassword(mailPassword) || mailPassword}
                    </Typography>
                  </Div>
                  <Div className="row">
                    <Typography className="input-label col-sm-11 col-md-4" sx={{ width: { xs: "33% ", md: "35%" } }}>
                      Last Login
                    </Typography>
                    <Typography className="input-label col-1">:</Typography>
                    <Typography className="input-label col-sm-12 col-md-7" sx={{ width: { xs: "55% ", md: "55%" } }}>
                      <DateFormatter date={userDetails?.last_login} /> {" "}
                      {userDetails?.last_login?.slice(11, 16)}{parseInt(userDetails?.last_login?.slice(11, 16), 10) >= 12 ? " PM" : " AM"}
                    </Typography>
                  </Div>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className="buttons" sx={{ display: "flex", justifyContent: "end" }}>
              <ErpSaveUpdateButton type="submit" name={"Update Profile"} width="auto !important" />
              <ErpCancelButton onClick={() => setOpenUserProfile(false)} />
            </DialogActions>
          </Div>
        </form>
      </Dialog> */}

      {/* dialog box for mail configuration */}
      <Dialog open={open} onClose={() => setOpen(false)}>
        <form onSubmit={handleSubmitMailConfigure}>
          <Div sx={{ p: 3, width: "500px" }}>
            <Typography variant="h3">Mail Configuration</Typography>
            <DialogContent>
              <Grid container spacing={1}>
                {/* Provider */}
                <Grid item xs={12} sm={12} md={12}>
                  {/* <Div className="row"> */}
                  <Typography className="input-label">
                    Provider <span className="required">*</span>
                  </Typography>
                  <Select
                    fullWidth
                    value={provider}
                    onChange={(e) => setProvider(e.target.value)}
                    className="input-select col-12"
                    defaultValue="select"
                  >
                    <MenuItem value="select" disabled>
                      Select
                    </MenuItem>
                    {Tenantname === "relux" && (
                      <MenuItem value="relux">Relux</MenuItem>
                    )}
                    <MenuItem value="gmail">Gmail</MenuItem>
                    <MenuItem value="outlook">Outlook</MenuItem>
                    <MenuItem value="godaddy">GoDaddy</MenuItem>
                    <MenuItem value="zoho">Zoho</MenuItem>
                    <MenuItem value="yahoo">Yahoo</MenuItem>
                    <MenuItem value="icloud">iCloud</MenuItem>
                  </Select>
                  {/* </Div> */}
                </Grid>

                <Grid item xs={12}>
                  {/* <Div className="row"> */}
                  <Typography className="input-label col-12">
                    Mail Id <span className="required">*</span>
                  </Typography>
                  <TextField
                    className="input-box col-12"
                    name="mailId"
                    value={mailId}
                    onChange={(e) => setMailId(e.target.value)}
                    placeholder="Enter Your Mail Id"
                    sx={{ minWidth: "350px" }}
                  />
                  {/* </Div> */}
                </Grid>

                <Grid item xs={12}>
                  {/* <Div className="row"> */}
                  <Typography className="input-label col-12">
                    {provider !== "godaddy" ? "App" : "Mail"} Password{" "}
                    <span className="required">*</span>
                  </Typography>
                  <TextField
                    className="input-box col-12"
                    type={showPassword ? "text" : "password"}
                    name="mailPassword"
                    value={mailPassword}
                    onChange={(e) => setMailPassword(e.target.value)}
                    placeholder="Enter Your Mail Password"
                    autoComplete="off"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{ minWidth: "300px" }}
                  />
                  {/* </Div> */}
                </Grid>
                {/* <Grid item>
                  <Div className="row">
                    <Typography className="input-label col-12">
                      SMTP Host <span className="required">*</span>
                    </Typography>
                    <TextField
                      className="input-box col-12 ps-2"
                      name="smtpHost"
                      value={smtpHost}
                      onChange={(e) => setSmtpHost(e.target.value)}
                      placeholder="Enter SMTP Host"
                      sx={{ minWidth: "320px" }}
                    />
                  </Div>
                </Grid>
                <Grid item>
                  <Div className="row">
                    <Typography className="input-label col-12">
                      SMTP Port <span className="required">*</span>
                    </Typography>
                    <TextField
                      className="input-box col-12 ps-2"
                      name="smtpPort"
                      value={smtpPort}
                      onChange={(e) => setSmtpPort(e.target.value)}
                      placeholder="Enter SMTP Port"
                      sx={{ minWidth: "320px" }}
                    />
                  </Div>
                </Grid>
                <Grid item>
                  <Div className="row">
                    <Typography className="input-label col-12">
                      IMAP Host <span className="required">*</span>
                    </Typography>
                    <TextField
                      className="input-box col-12 ps-2"
                      name="imapHost"
                      value={imapHost}
                      onChange={(e) => setImapHost(e.target.value)}
                      placeholder="Enter IMAP Host"
                      sx={{ minWidth: "320px" }}
                    />
                  </Div>
                </Grid>
                <Grid item>
                  <Div className="row">
                    <Typography className="input-label col-12">
                      IMAP Port <span className="required">*</span>
                    </Typography>
                    <TextField
                      className="input-box col-12 ps-2"
                      name="imapPort"
                      value={imapPort}
                      onChange={(e) => setImapPort(e.target.value)}
                      placeholder="Enter IMAP Port"
                      sx={{ minWidth: "320px" }}
                    />
                  </Div>
                </Grid> */}
                {/* <Grid item>
                  <Div className="row">
                    <Typography className="input-label col-12">
                      Secret Key <span className="required">*</span>
                    </Typography>
                    <TextField
                      className="input-box col-12 ps-2"
                      name="secretKey"
                      value={secretKey}
                      onChange={(e) => setSecretKey(e.target.value)}
                      placeholder="Enter Secret Key"
                      sx={{ minWidth: "320px" }}
                    />
                  </Div>
                </Grid>
                <Grid item>
                  <Div className="row">
                    <Typography className="input-label col-12">
                      Access Token <span className="required">*</span>
                    </Typography>
                    <TextField
                      className="input-box col-12 ps-2"
                      name="accessToken"
                      value={accessToken}
                      onChange={(e) => setAccessToken(e.target.value)}
                      placeholder="Enter Access Token"
                      sx={{ minWidth: "320px" }}
                    />
                  </Div>
                </Grid>
                <Grid item>
                  <Div className="row">
                    <Typography className="input-label col-12">
                      Client Id <span className="required">*</span>
                    </Typography>
                    <TextField
                      className="input-box col-12 ps-2"
                      name="clientId"
                      value={clientId}
                      onChange={(e) => setClientId(e.target.value)}
                      placeholder="Enter Client Id"
                      sx={{ minWidth: "340px" }}
                    />
                  </Div>
                </Grid> */}
              </Grid>
            </DialogContent>
            <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
              <ErpSaveUpdateButton
                name={id ? "Update" : "Submit"}
                type={"submit"}
              />
              <ErpCancelButton onClick={() => setOpen(false)} />
            </DialogActions>
          </Div>
        </form>
      </Dialog>
    </ThemeProvider>
  );
};

export default AuthUserDropdown;
